<template>
  <div id="app" class="is-dark">
    <Navbar />
    <Home />
    <Footer id="footer" />
  </div>
</template>

<script>
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
export default {
  components: {
    Navbar,
    Footer
  },
  metaInfo: {
    title: "Meet John",
    titleTemplate: null,
    meta: [
      { name: "Meet John", content: "Online Portfolio of John Nguyen" },
      { property: "og:title", content: "Meet John" },
      { property: "og:site_name", content: "Meet John" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.meetjohn.xyz" },
      {
        property: "og:image",
        content: "https://meetjohn.xyz/img/profile.2aed145b.jpg"
      },
      {
        property: "og:description",
        content: "Online portfolio of multifaceted creator, John Nguyen"
      },

      {
        name: "twitter:card",
        content: "Online portfolio of multifaceted creator, John Nguyen"
      },
      {
        name: "twitter:site",
        content: "https://www.my-site.com/my-special-page"
      },
      { name: "twitter:title", content: "Meet John" },
      {
        name: "twitter:description",
        content: "Meet John, a creator and educator"
      },
      {
        name: "twitter:image:src",
        content: "https://meetjohn.xyz/img/profile.2aed145b.jpg"
      },

      { itemprop: "name", content: "Meet John" },
      {
        itemprop: "description",
        content: "Online portfolio of multifaceted creator, John Nguyen"
      },
      {
        itemprop: "image",
        content: "https://meetjohn.xyz/img/profile.2aed145b.jpg"
      }
    ],
    link: [{ rel: "canonical", href: "https://www.meetjohn.xyz" }]
  }
};
</script>
<style lang="scss">
#app {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: rgba(255, 126, 107, 1);
  height: 100%;
}
#footer {
  display: block;
  position: relative;
}
</style>
